import React from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import useBackdropClose from "../../hooks/useBackdropClose";
import { MOOD_ICONS } from "../../config/moodIcons";
import {
  Overlay, Modal, Header, Title, CloseButton,
  Question, QuestionLabel, Answer, MoodAnswer, MoodIcon,
} from "./styles";

/**
 * Respuestas del Weekly Form de una semana, en solo lectura, para el terapeuta.
 * Reutiliza los textos de preguntas y opciones del formulario del paciente.
 */
const WeeklyFormSummaryModal = ({ weekNumber, form, onClose }) => {
  const { t } = useTranslation();

  return createPortal(
    <Overlay {...useBackdropClose(onClose)}>
      <Modal onClick={(e) => e.stopPropagation()}>
        <Header>
          <Title>{t("summary.formTitle", { number: weekNumber })}</Title>
          <CloseButton type="button" onClick={onClose} aria-label={t("summary.close")}>×</CloseButton>
        </Header>

        <Question>
          <QuestionLabel>{t("weeklyForm.questions.activity_frequency")}</QuestionLabel>
          <Answer>{t(`weeklyForm.options.activity_frequency.${form.activity_frequency}`)}</Answer>
        </Question>

        <Question>
          <QuestionLabel>{t("weeklyForm.questions.performance")}</QuestionLabel>
          <Answer>{t(`weeklyForm.options.performance.${form.performance}`)}</Answer>
        </Question>

        <Question>
          <QuestionLabel>{t("weeklyForm.questions.mood")}</QuestionLabel>
          <MoodAnswer as="div">
            <MoodIcon src={MOOD_ICONS[form.mood]} alt="" />
            {t(`weeklyForm.options.mood.${form.mood}`)}
          </MoodAnswer>
        </Question>

        <Question>
          <QuestionLabel>{t("weeklyForm.questions.notes")}</QuestionLabel>
          <Answer>{form.notes || "—"}</Answer>
        </Question>
      </Modal>
    </Overlay>,
    document.body
  );
};

export default WeeklyFormSummaryModal;
